<template>
  <div>
    <el-form
      ref="settingCon"
      :model="settingCon"
      label-width="100px"
      :rules="settingRules"
    >
      <el-card>
        <div
          slot="header"
          class="clearfix"
        >
          <span>基础信息 </span>
        </div>
        <div>
          <el-form-item label="是否开启：">
            <el-switch
              v-model="is_active"
              active-color="#13ce66"
              inactive-color="#999999"
            />
            <div class="form-text-tip">
              开启后系统将会在客户成功添加导购后下发红包到客户聊天页。
            </div>
          </el-form-item>
        </div>
      </el-card>
      <el-card style="margin-top: 20px">
        <div
          slot="header"
          class="clearfix"
        >
          <span>发放规则 </span>
        </div>
        <div>
          <el-form-item label="总额度：">
            <div>
              <el-input
                v-model="settingCon.total_money"
                class="input-b m-r-6"
                placeholder="请输入红包限额"
              />元
            </div>
            <div class="form-text-tip">
              达到限额后活动结束，不设置将无上限活动一直存在。
            </div>
          </el-form-item>
          <el-form-item
            prop="money_type"
            label="红包类型："
          >
            <el-radio-group v-model="settingCon.money_type">
              <el-radio :label="'fixed'">
                固定金额
              </el-radio>
              <el-radio :label="'random'">
                随机金额
              </el-radio>
            </el-radio-group>
            <div class="form-text-tip">
              开启红包金额将在红包金额区间进行随机发放，关闭后将发送固定金额红包。
            </div>
          </el-form-item>
          <template v-if="settingCon.money_type === 'fixed'">
            <el-form-item
              prop="min_money"
              label="红包金额："
            >
              <div>
                <el-input
                  v-model="settingCon.min_money"
                  class="input-b m-r-6"
                  placeholder="请输入红包限额"
                />元
              </div>
            </el-form-item>
          </template>
          <template v-if="settingCon.money_type === 'random'">
            <el-form-item
              prop="max_money"
              label="红包金额："
            >
              <div>
                <el-input
                  v-model="settingCon.min_money"
                  class="input-s m-r-6"
                />～
                <el-input
                  v-model="settingCon.max_money"
                  class="input-s m-l-6 m-r-6"
                />元
              </div>
            </el-form-item>
          </template>

          <el-form-item
            label="活动时间段："
            prop="time"
          >
            <el-date-picker
              v-model="activeDate"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="dateChange"
            />
          </el-form-item>
          <el-form-item label="发放类型：">
            <el-radio-group v-model="settingCon.send_type">
              <el-radio :label="'at_once'">
                立即发放
              </el-radio>
              <el-radio :label="'delay'">
                延时发放
              </el-radio>
              <el-radio :label="'timing'">
                定时发放
              </el-radio>
            </el-radio-group>
            <div class="form-text-tip">
              延时发放设定时常，定时发放因红包发放数量较大会有部分延迟(活动时间为必填)
            </div>
          </el-form-item>
          <template v-if="settingCon.send_type === 'delay'">
            <el-form-item
              prop="min"
              label="延时时长"
            >
              <div>
                <el-input
                  v-model="settingCon.day"
                  class="input-s m-r-6"
                />天
                <el-input
                  v-model="settingCon.hour"
                  class="input-s m-l-6 m-r-6"
                />时
                <el-input
                  v-model="settingCon.min"
                  class="input-s m-l-6 m-r-6"
                />分
              </div>
            </el-form-item>
          </template>
          <template v-if="settingCon.send_type === 'timing'">
            <el-form-item label="定时发放：">
              <el-date-picker
                v-model="settingCon.due_time"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
              />
            </el-form-item>
          </template>
          <el-form-item label="">
            <el-button
              type="primary"
              @click="saveSettings('settingCon')"
            >
              保存配置
            </el-button>
          </el-form-item>
        </div>
      </el-card>
    </el-form>
  </div>
</template>
<script>
import { saveRedEnvelope } from '@/api/activity/redpage'
export default {
  data () {
    return {
      settingRules: {
        min_money: [{ required: true, message: '请输入红包金额', trigger: 'blur' }],
        max_money: [{ required: true, message: '请输入红包金额', trigger: 'blur' }],
        day: [{ required: true, message: '请输入延长时间', trigger: 'blur' }],
        hour: [{ required: true, message: '请输入延长时间', trigger: 'blur' }],
        min: [{ required: true, message: '请输入延长时间', trigger: 'blur' }],
        money_type: [{ required: true, message: '请选择活动资源', trigger: 'change' }]
      },
      activeName: 'redSetting',
      //redSettingForm: {},
      settingCon: {
        //day:'',
        //hour:'',
        //min:'',
        // total_money:null, //总额度
        //money_type:'fixed',//红包类型(fixed 固定,random，随机)
        //min_money:null,//单个红包额度(最小值)	,
        // max_money:null,//单个红包额度(最大值)
        // begin_time:null,//活动开始时间(Y-m-d H:i:s)
        // end_time:null,//活动结束时间(Y-m-d H:i:s)
        //send_type:'at_once',//发放类型(at_once,delay,timing)
        // due_time:null//定时时间
      },
      activeDate: '', //活动时间段

      is_active: true
    }
  },
  mounted () {},
  methods: {
    dateChange (e) {
      if (e) {
        this.settingCon.begin_time = e[0]
        this.settingCon.end_time = e[1]
      }
    },

    saveSettings (ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          const params = {
            coupon_type: 'newbie',
            config: this.settingCon,
            is_active: this.is_active
          }
          saveRedEnvelope(params).then((res) => {
            if (res.status) {
              return this.$message.success('保存成功')
            } else {
              return this.$message.error('失败')
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
